import React from 'react';
import { graphTypeEnums, goalGraphTypeEnums, goalGraphValueModeEnums } from '../../attributes/constnats';
import { FormLineChart, FormBarChart } from '../../../fragments/formGraphs';
import { ToolInfo } from 'components';

const DEMO_CATEGORIES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
const DEMO_SERIES = [{ name: 'Progress', data: [20, 35, 45, 60, 72, 85] }];
// Cumulative in Count mode: mastered targets out of DEMO_TARGET_COUNT.
const DEMO_TARGET_COUNT = 10;
const DEMO_COUNT_SERIES = [{ name: 'Progress', data: [2, 3, 4, 6, 7, 8] }];

export const GraphElement = ({ item }) => {
    const chartSettings = item?.properties?.chartSettings || {};
    const isCountMode =
        (item?.defaultDateType || goalGraphTypeEnums.CUMULATIVE) === goalGraphTypeEnums.CUMULATIVE &&
        item?.properties?.valueMode === goalGraphValueModeEnums.COUNT;
    const series = isCountMode ? DEMO_COUNT_SERIES : DEMO_SERIES;
    const countMax = isCountMode ? DEMO_TARGET_COUNT : undefined;

    return (
        <div>
            {/*<div className="space-between">*/}

            {/*    <div/>*/}

            {/*    /!*<div>*!/*/}
            {/*    /!*    {chartSettings?.chartTitle &&*!/*/}
            {/*    /!*        <p className="form-builder-attribute-title">*!/*/}
            {/*    /!*            {chartSettings.chartTitle}*!/*/}
            {/*    /!*        </p>*!/*/}
            {/*    /!*    }*!/*/}
            {/*    /!*    {chartSettings?.chartSubtitle &&*!/*/}
            {/*    /!*        <p className="form-builder-attribute-sub-title">{chartSettings.chartSubtitle}</p>*!/*/}
            {/*    /!*    }*!/*/}
            {/*    /!*</div>*!/*/}

            {/*    <div>*/}
            {/*        <ToolInfo text={'Some example data'} />*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div>
                {item?.properties?.graphType === graphTypeEnums.LINE && (
                    <FormLineChart
                        item={item}
                        categories={DEMO_CATEGORIES}
                        series={series}
                        isPercent={!isCountMode}
                        countMax={countMax}
                        seriesConfig={item?.properties?.chartSettings?.seriesConfig || []}
                    />
                )}
                {item?.properties?.graphType === graphTypeEnums.BAR && (
                    <FormBarChart
                        item={item}
                        categories={DEMO_CATEGORIES}
                        series={series}
                        isPercent={!isCountMode}
                        countMax={countMax}
                        seriesConfig={item?.properties?.chartSettings?.seriesConfig || []}
                    />
                )}
            </div>
        </div>
    );
};
